import {Component, OnDestroy, OnInit} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {ValidationResult} from '../../common/cell-validate-import.result';

@Component({
  selector: 'mydocma-mm-valid-status.cell-renderer',
  templateUrl: './valid-status.cell-renderer.component.html',
  styleUrls: ['./valid-status.cell-renderer.component.scss']
})
export class ValidStatusCellRendererComponent implements ICellRendererAngularComp, OnInit, OnDestroy {

  private params: ICellRendererParams;
  public value: ValidationResult;

  public validationResults = ValidationResult;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value as ValidationResult
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams<any>): boolean {
    this.params = params;
    const doRefresh = this.value !== params.value;
    this.value = params.value as ValidationResult
    return doRefresh;
  }

}
